<div class="footer-container mt-5">
  <img class="w-100 footer-img" src="../../../assets/img/footer.png" />
  <div class="details">
    <img class="logo mb-4" src="../../../assets/img/white-logo.png" />
    <div class="text">
      {{ "We are UP CAREER" | translate }}
    </div>
    <button class="border-button">{{ "Get Start" | translate }}</button>
  </div>
</div>

<div class="mx-3 mx-md-5 my-3">
  <div class="d-sm-flex d-block justify-content-between align-items-center">
    <div class="d-flex gap-4 social-text">
      <div routerLink="" fragment="services">
        {{ "Services" | translate }}
      </div>
      <div routerLink="/contact">{{ "Contact" | translate }}</div>
      <div routerLink="/policy">{{ "policy" | translate }}</div>
      <div routerLink="/FQA">{{ "FQA" | translate }}</div>

      <!-- <div>{{ "Feedback" | translate }}</div> -->
    </div>
    <div class="d-flex gap-4 mt-3 mt-sm-auto social justify-content-start">
      <a href="https://www.linkedin.com/company/up-career/" target="_blank">
        <img src="../../../assets/icon/linkedin.svg" alt="LinkedIn" />
      </a>
      <a
        href="https://www.facebook.com/@upcareer.CV/?mibextid=ZbWKwL"
        target="_blank"
      >
        <img src="../../../assets/icon/facebook.svg" alt="Facebook" />
      </a>
      <a href="https://x.com/upcareer2022?s=09" target="_blank">
        <img src="../../../assets/icon/twitter.svg" alt="Twitter" />
      </a>
    </div>
  </div>
  <hr />
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <img width="30%" class="me-2" src="../../../assets/img/logo.png" />

      <span>UP CAREER</span>
    </div>

    <div class="social-text">2024 {{ "All rights reserved" | translate }}</div>
  </div>
</div>
